// Add these functions to manage body overflow
function addBodyOverflowHidden() {
  document.body.classList.add("overflow-hidden");
}

function removeBodyOverflowHidden() {
  document.body.classList.remove("overflow-hidden");
}

/** Customer-facing line-item property key for shipping/ribbon fees (matches multi-ship-new.js LINE_ITEM_PROP_KEYS.fees). */
const PDP_LINE_PROP_FEES = "Fees";

function getSignatureFeeCartLineFromConfig() {
  const cfg =
    typeof window !== "undefined" ? window.expressCheckoutConfig || {} : {};
  const variantId = cfg.signatureFeeVariantId;
  if (variantId == null || variantId === "") return null;
  const cents = Number(cfg.signatureFeePriceCents);
  const feeDisplay =
    !isNaN(cents) ? "$" + (cents / 100).toFixed(2) : "$0.00";
  return {
    id: variantId,
    feeDisplay,
  };
}

if (typeof window !== "undefined") {
  window.chukarGetSignatureFeeCartLine = getSignatureFeeCartLineFromConfig;
}

function cartLineIsSignatureFeeForGid(line, gid) {
  if (!line || !line.properties || gid == null) return false;
  const lg = line.properties._gid != null ? String(line.properties._gid) : "";
  if (lg !== String(gid)) return false;
  if (line.properties._fee === true || line.properties._fee === "true") return true;
  if (line.handle === "signature-fee") return true;
  if (line.title && String(line.title).includes("Adult Signature Fee")) return true;
  const cfg =
    typeof window !== "undefined" ? window.expressCheckoutConfig || {} : {};
  if (cfg.signatureFeeVariantId != null) {
    const vid = line.variant_id != null ? line.variant_id : line.id;
    if (vid != null && String(vid) === String(cfg.signatureFeeVariantId)) return true;
  }
  return false;
}

function cartHasSignatureFeeForGid(cartItems, gid) {
  if (!gid || !Array.isArray(cartItems)) return false;
  for (let i = 0; i < cartItems.length; i++) {
    const it = cartItems[i];
    if (!it) continue;
    if (Array.isArray(it.item_components)) {
      for (let j = 0; j < it.item_components.length; j++) {
        if (cartLineIsSignatureFeeForGid(it.item_components[j], gid)) return true;
      }
    }
    if (cartLineIsSignatureFeeForGid(it, gid)) return true;
  }
  return false;
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.wine = false;
        this.zipCodeZones = null; // Will store the ZIP code zone data
        this.isZipCodeValid = false; // Track if ZIP code is valid
        this.restrictedStates = this.dataset.restrictedStates;
        // Detect gift card without relying on dataset (works even if Liquid flag removed)
        this.isGiftCard =
          (this.dataset && this.dataset.isGiftCard === "true") ||
          !!document.querySelector("recipient-form") ||
          !!document.querySelector('input[name="properties[Recipient email]"]');

        if (document.querySelector(".product-warning__container--wine")) {
          this.wine = true;
        }

        // Add event listener for age verification checkbox to auto-clear warnings when checked
        const ageVerification = document.querySelector(
          "#ProductAgeVerification"
        );
        if (ageVerification) {
          ageVerification.addEventListener("change", (e) => {
            if (e.target.checked) {
              // Clear any warning state when the checkbox is checked
              e.target.parentNode.classList.remove("warning");
            }
          });
        }

        this.personalMessage = this.querySelector("personal-message");

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        // this.submitButtonText = this.submitButton.querySelector('span');

        // Set up shipping date selection modal and save button
        this.shippingMethodModel = document.querySelector(
          "#delivery-date-group"
        );
        this.modalCloseBtn = this.shippingMethodModel
          ? this.shippingMethodModel.querySelector(".modal-close_btn")
          : null;
        this.zipCodeInput = document.querySelector('input[id="zipcode"]');
        // Cache recipient email input for gift card products (if present)
        this.recipientEmailInput = document.querySelector(
          'input[name="properties[Recipient email]"]'
        );

        // Load ZIP code data
        this.loadZipCodeData();

        // Add direct click handler for calendar cells (as a backup to ensure selection is recognized)
        document.addEventListener("click", (e) => {
          const cell = e.target.closest(
            ".air-datepicker-cell:not(.-disabled-)"
          );
          if (cell && this.shippingMethodModel.classList.contains("active")) {
            console.log("Calendar cell clicked: ", cell.textContent);

            // Mark that a date has been selected
            const productElement =
              this.shippingMethodModel.querySelector(".product");
            if (productElement) {
              productElement.classList.add("Selecteddate");
              productElement.classList.remove("calender-error");
            }

            // Remove any error styling
            const calendarContainer = this.shippingMethodModel.querySelector(
              ".multiship-calendar__container"
            );
            if (calendarContainer) {
              calendarContainer.classList.remove("error-highlight");
            }

            // Remove any error messages
            this.shippingMethodModel
              .querySelectorAll(".error-message")
              .forEach((el) => el.remove());
          }
        });

        // Listen for date selection event to show confirmation popup (calendar stays open)
        document.addEventListener("deliveryDateSelected", (e) => {
          this.handleDateSelected();
        });

        // Listen for date confirmation event (when Confirm button is clicked)
        document.addEventListener("dateConfirmed", (e) => {
          this.handleDateConfirmed();
        });

        // Close modal button click handler - validate date selection before closing
        if (this.modalCloseBtn) {
          this.modalCloseBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            this.handleModalClose();
          });
        }

        // Handle clicking outside modal to close (if applicable)
        if (this.shippingMethodModel) {
          this.shippingMethodModel.addEventListener("click", (e) => {
            // If clicking on the backdrop (the modal container itself, not its children)
            if (e.target === this.shippingMethodModel) {
              e.stopPropagation();
              this.handleModalClose();
            }
          });
        }

        // Handle ESC key to close modal
        const escKeyHandler = (e) => {
          if (
            e.key === "Escape" &&
            this.shippingMethodModel &&
            this.shippingMethodModel.classList.contains("active")
          ) {
            e.stopPropagation();
            this.handleModalClose();
          }
        };
        document.addEventListener("keydown", escKeyHandler);

        // Add event listener for ZIP code input
        if (this.zipCodeInput) {
          this.zipCodeInput.addEventListener(
            "input",
            this.handleZipCodeInput.bind(this)
          );
          this.zipCodeInput.addEventListener(
            "blur",
            this.validateZipCode.bind(this)
          );
        }

        // Clear email error while typing
        if (this.recipientEmailInput) {
          this.recipientEmailInput.addEventListener("input", () => {
            this.hideEmailError();
          });
        }

        // Set up event listeners for personal message to auto-clear warnings
        if (this.personalMessage) {
          const optOut = this.personalMessage.querySelector(
            ".personal-message__opt-out input"
          );
          const messageInputs = this.personalMessage.querySelectorAll(
            ".personal-message__body"
          );

          // Clear warnings when user starts interacting with personal message
          if (optOut) {
            optOut.addEventListener("change", () => {
              this.personalMessage.classList.remove("warning");
              this.personalMessage.removeWarning();
            });
          }

          messageInputs.forEach((input) => {
            input.addEventListener("input", () => {
              this.personalMessage.classList.remove("warning");
            });
          });
        }

        // Track form submission state
        this.formSubmissionPending = false;
        this.formData = null;
        this.isClosingModal = false; // Flag to prevent duplicate alerts

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      clearFormFields() {
        // Clear zipcode input
        if (this.zipCodeInput) {
          this.zipCodeInput.value = "";
          this.isZipCodeValid = false;
          this.hideZipCodeError();
        }

        // Clear delivery date selection
        const shippingMethods = document.querySelector("shipping-methods");
        if (shippingMethods) {
          // Clear any selected date in the calendar
          if (shippingMethods.airDatepicker) {
            shippingMethods.airDatepicker.clear();
          }

          // Reset any UI elements showing selected dates
          const productElement = document.querySelector(".product");
          if (productElement) {
            productElement.classList.remove("Selecteddate");
          }

          // Reset delivery estimate displays
          const deliveryEstimates =
            document.querySelectorAll(".delivery-estimate");
          deliveryEstimates.forEach((estimate) => {
            // Only reset if we can find the original estimate text format
            const originalType = estimate.dataset.type;
            if (originalType) {
              // Keep the original shipping estimate format based on type
              let estimate_string = "";
              if (originalType == "standard") estimate_string = "2 - 5 Days";
              else if (originalType == "expedited") estimate_string = "2 Days";
              else if (originalType == "overnight") estimate_string = "1 Day";

              estimate.innerHTML = `Estimated Delivery Date: <b class='delivery-date'>${estimate_string}</b>`;
            }
          });

          // Hide the date selection message
          this.hideDateSelectedMessage();
        }
      }

      // Load ZIP code data from the JSON file
      //https://cdn.shopify.com/s/files/1/0761/9903/5189/files/zip_code.json?v=1733463661
      loadZipCodeData() {
        fetch(
          "https://cdn.shopify.com/s/files/1/0677/7936/2886/files/transit-times-zip.json?v=1776073082"
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                "Network response was not ok " + response.statusText
              );
            }
            return response.json();
          })
          .then((data) => {
            this.zipCodeZones = this.processZipCodeData(data);
            console.log("ZIP code data loaded successfully");
          })
          .catch((error) => {
            console.error("Error loading ZIP code data:", error);
          });
      }

      // Process ZIP code data into formats useful for validation
      processZipCodeData(data) {
        let zones = {
          SCzones1: [],
          SCzones2: [],
          SCzones3: [],
          SCzones4: [],
          SCzones5: [],
          SCzones6: [],
          all: [],
        };

        // Store state information along with zip code
        let zipCodeToState = {};

        Object.keys(data).forEach((key) => {
          // Safety check: ensure data[key] is an array before iterating
          if (Array.isArray(data[key])) {
            data[key].forEach((item) => {
              // Safety check: ensure item exists and has required properties
              if (item && item.State && item["Postal Code"] !== undefined) {
                const zipCode = `${item["Postal Code"]}`;
                zones.all.push(zipCode);

                // Store the state associated with the zip code
                zipCodeToState[zipCode] = item["State"];

                // Map service days to zones correctly (matching shipping-method-pdp.js)
                if (item["Service Days"] === 1) {
                  zones.SCzones1.push(zipCode);
                } else if (item["Service Days"] === 2) {
                  zones.SCzones2.push(zipCode);
                } else if (item["Service Days"] === 3) {
                  zones.SCzones3.push(zipCode);
                } else if (item["Service Days"] === 4) {
                  zones.SCzones4.push(zipCode);
                } else if (item["Service Days"] === 5) {
                  zones.SCzones5.push(zipCode);
                } else if (item["Service Days"] === 6) {
                  zones.SCzones6.push(zipCode);
                }
              }
            });
          }
        });

        // Add zipCodeToState to the zones object
        zones.zipCodeToState = zipCodeToState;

        return zones;
      }

      // Function to get the state for a given zip code
      getStateForZipCode(zipCode) {
        // Normalize zip code
        const normalizedZip = zipCode.replace(/^0+/, "");
        if (this.zipCodeZones && this.zipCodeZones.zipCodeToState) {
          return this.zipCodeZones.zipCodeToState[normalizedZip];
        }
        return null;
      }

      // Determine the main product unit price on the PDP.
      // This mirrors the logic in shipping-method-pdp.js so tiers and _main_fees stay in sync.
      getMainProductUnitPrice() {
        try {
          let productPrice = 0;

          // Find the product container
          const productEl =
            this.querySelector(".product") || document.querySelector(".product");

          // Method 1: product JSON (most reliable)
          if (window.productData || window.Product || productEl?.dataset?.productJson) {
            try {
              const productJson =
                window.productData ||
                window.Product ||
                JSON.parse(productEl.dataset.productJson || "{}");
              const selectedVariant =
                productJson.selected_or_first_available_variant ||
                (Array.isArray(productJson.variants)
                  ? productJson.variants[0]
                  : null);
              if (selectedVariant && selectedVariant.price) {
                // Shopify prices are in cents
                productPrice = parseFloat(selectedVariant.price) / 100;
              }
            } catch (e) {
              console.warn("ProductForm.getMainProductUnitPrice: JSON parse failed", e);
            }
          }

          // Method 2: look for price elements in the DOM
          if (!productPrice) {
            const selectors = [
              ".product__price .price__regular .price-item--regular",
              ".product__price .price-item--regular",
              ".price .price-item--regular",
              "[data-product-price]",
              ".product-single__price .price",
              ".product-price .price",
              ".price--on-sale",
              ".price--regular",
              ".product__price",
              "[data-price]",
            ];

            let priceElement = null;
            for (const sel of selectors) {
              priceElement = productEl ? productEl.querySelector(sel) : null;
              if (priceElement) break;
            }
            if (!priceElement) {
              for (const sel of selectors) {
                priceElement = document.querySelector(sel);
                if (priceElement) break;
              }
            }

            if (priceElement) {
              // Prefer data attributes (often in cents)
              const raw =
                priceElement.getAttribute("data-price") ||
                priceElement.getAttribute("data-product-price") ||
                priceElement.getAttribute("data-variant-price");
              if (raw) {
                const val = parseFloat(raw);
                if (!isNaN(val)) {
                  productPrice = raw.includes(".") || val < 100 ? val : val / 100;
                }
              } else {
                const text = priceElement.textContent || "";
                const match = text.match(/[\d,]+\.?\d*/);
                if (match) {
                  const extracted = parseFloat(match[0].replace(/,/g, ""));
                  if (!isNaN(extracted)) {
                    productPrice =
                      text.includes(".") || extracted < 100
                        ? extracted
                        : extracted / 100;
                  }
                }
              }
            }
          }

          if (!productPrice || isNaN(productPrice)) {
            return 0;
          }

          return productPrice;
        } catch (e) {
          console.warn("ProductForm.getMainProductUnitPrice failed", e);
          return 0;
        }
      }

      // Handle ZIP code input to limit to digits and max 5 characters
      handleZipCodeInput(event) {
        let value = event.target.value;

        // Remove non-digit characters
        value = value.replace(/\D/g, "");

        // Limit to 5 digits
        if (value.length > 5) {
          value = value.slice(0, 5);
        }

        // Update the input value
        event.target.value = value;

        // Hide error messages when typing
        this.hideZipCodeError();
      }

      // Hide ZIP code error messages
      hideZipCodeError() {
        const zipCodeBlankError = document.querySelector(
          ".zipcode_blank_error"
        );
        if (zipCodeBlankError) {
          zipCodeBlankError.style.display = "none";
        }

        const zipErrorMessage = document.querySelector(".zip-error-message");
        if (zipErrorMessage) {
          zipErrorMessage.remove();
        }

        this.zipCodeInput.style.border = "";
      }

      // Focus Recipient Email input if present
      focusRecipientEmail() {
        if (this.recipientEmailInput) {
          // Use setTimeout to ensure focus after any UI updates
          setTimeout(() => {
            this.recipientEmailInput.focus();
            try {
              this.recipientEmailInput.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            } catch (e) {
              // no-op if scrollIntoView not supported
            }
          }, 50);
        }
      }

      // Hide Recipient Email error message and styling
      hideEmailError() {
        if (!this.recipientEmailInput) return;
        this.recipientEmailInput.style.border = "";
        // Prefer using the existing error block in gift card form if available
        const emailErrorBlock = document.querySelector(
          '[id^="RecipientForm-email-error-"]'
        );
        if (emailErrorBlock) {
          emailErrorBlock.classList.add("hidden");
          const span = emailErrorBlock.querySelector(".error-message");
          if (span) span.textContent = "";
        }
        // Remove fallback inline error if created
        const fallback = this.recipientEmailInput.parentNode?.querySelector(
          ".email-error-message"
        );
        if (fallback) fallback.remove();
      }

      // Show Recipient Email error message near the input
      showEmailError(message) {
        if (!this.recipientEmailInput) return;
        this.recipientEmailInput.style.border = "1px solid red";

        // Ensure Recipient Information section is "open" (checkbox checked)
        try {
          const recipientForm =
            this.recipientEmailInput.closest("recipient-form") ||
            document.querySelector("recipient-form");
          if (recipientForm) {
            const checkbox = recipientForm.querySelector(
              '[id^="Recipient-checkbox-"]'
            );
            if (checkbox && !checkbox.checked) {
              checkbox.checked = true;
              // trigger change so inputs get enabled
              checkbox.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        } catch (e) {
          // fail silently if recipient-form not present
        }

        // Try themed error container first
        const emailErrorBlock = document.querySelector(
          '[id^="RecipientForm-email-error-"]'
        );
        if (emailErrorBlock) {
          emailErrorBlock.classList.remove("hidden");
          const span = emailErrorBlock.querySelector(".error-message");
          if (span) span.textContent = message;
          // bring field into view and focus
          this.focusRecipientEmail();
          return;
        }

        // Fallback: simple inline paragraph after the input
        let inline = this.recipientEmailInput.parentNode?.querySelector(
          ".email-error-message"
        );
        if (!inline) {
          inline = document.createElement("p");
          inline.className = "email-error-message";
          inline.style.color = "red";
          inline.style.fontSize = "14px";
          inline.style.marginTop = "5px";
          this.recipientEmailInput.parentNode?.insertBefore(
            inline,
            this.recipientEmailInput.nextSibling
          );
        }
        inline.textContent = message;
        this.focusRecipientEmail();
      }

      // Validate Recipient Email if present (gift card products)
      validateRecipientEmail() {
        // If there's no email field (non gift-card), consider valid
        if (!this.recipientEmailInput) return true;

        const value = (this.recipientEmailInput.value || "").trim();
        if (!value) {
          this.showEmailError("Recipient email is required.");
          return false;
        }
        // Simple, robust email pattern
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
          this.showEmailError("Please enter a valid email address.");
          return false;
        }

        // Passed validation
        this.hideEmailError();
        return true;
      }

      // Validate ZIP code against loaded data
      validateZipCode() {
        // Reset validation state
        this.isZipCodeValid = false;
        this.hideZipCodeError();

        const zipValue = this.zipCodeInput.value.trim();

        // Check if ZIP code is empty
        if (!zipValue) {
          const zipCodeBlankError = document.querySelector(
            ".zipcode_blank_error"
          );
          if (zipCodeBlankError) {
            zipCodeBlankError.style.display = "block";
          }
          this.zipCodeInput.style.border = "1px solid red";
          return false;
        }

        // Check length
        if (zipValue.length < 5) {
          this.showZipCodeError("Please enter a valid 5-digit ZIP code");
          return false;
        }

        // Check if ZIP code exists in our data
        if (!this.zipCodeZones || !this.zipCodeZones.all) {
          console.log("ZIP code data not yet loaded, assuming valid");
          this.isZipCodeValid = true;
          return true;
        }

        // Get ZIP code without leading zeros for comparison
        const normalizedZip = zipValue.replace(/^0+/, "");

        if (this.zipCodeZones.all.includes(normalizedZip)) {
          console.log("ZIP code is valid: " + zipValue);
          this.isZipCodeValid = true;

          // Get the state associated with the zip code
          const state = this.getStateForZipCode(normalizedZip);

          // Check if the state is in the restricted list
          if (
            this.restrictedStates &&
            state &&
            this.restrictedStates.includes(state)
          ) {
            this.showZipCodeError(
              `Due to state regulations, we’re unable to ship alcohol gifts to ${state}. <a href="/collections/wine-and-chocolate-gifts" rel="noopener noreferrer" style="text-decoration:underline;">Click here</a> and send one of our top-selling gifts available for this ZIP code!`
            );
            return false;
          }

          // Determine the zone (matching shipping-method-pdp.js zone mapping)
          let zone = null;
          if (this.zipCodeZones.SCzones1 && this.zipCodeZones.SCzones1.includes(normalizedZip)) {
            zone = "SCzones1";
          } else if (this.zipCodeZones.SCzones2 && this.zipCodeZones.SCzones2.includes(normalizedZip)) {
            zone = "SCzones2";
          } else if (this.zipCodeZones.SCzones3 && this.zipCodeZones.SCzones3.includes(normalizedZip)) {
            zone = "SCzones3";
          } else if (this.zipCodeZones.SCzones4 && this.zipCodeZones.SCzones4.includes(normalizedZip)) {
            zone = "SCzones4";
          } else if (this.zipCodeZones.SCzones5 && this.zipCodeZones.SCzones5.includes(normalizedZip)) {
            zone = "SCzones5";
          } else if (this.zipCodeZones.SCzones6 && this.zipCodeZones.SCzones6.includes(normalizedZip)) {
            zone = "SCzones6";
          }

          // Store the zone as a data attribute for later use
          if (zone) {
            this.zipCodeInput.setAttribute("data-zone", zone);
            this.zipCodeInput.setAttribute("zone", zone);
            const productElement =
              this.shippingMethodModel.querySelector(".product");
            if (productElement) {
              productElement.setAttribute("zone", zone);
              console.log(`Zone ${zone} set on product element for ZIP: ${zipValue}`);
            }
            
            // Trigger calendar update if shipping-methods component exists
            const shippingMethods = this.shippingMethodModel.querySelector("shipping-methods");
            if (shippingMethods) {
              // Force calendar to re-render with new zone
              if (shippingMethods.airDatepicker) {
                setTimeout(() => {
                  shippingMethods.airDatepicker.update();
                  console.log(`Calendar updated with zone ${zone}`);
                }, 200);
              } else {
                // If calendar not initialized yet, wait a bit and try again
                setTimeout(() => {
                  if (shippingMethods.airDatepicker) {
                    shippingMethods.airDatepicker.update();
                    console.log(`Calendar updated with zone ${zone} (delayed)`);
                  }
                }, 500);
              }
            }
          }

          // Move user to the Recipient Email field after a valid zipcode
          this.focusRecipientEmail();

          return true;
        } else {
          this.showZipCodeError("Not available in our service area");
          return false;
        }
      }

      // Show ZIP code error message
      showZipCodeError(message) {
        if (!this.zipCodeInput) return; // Add check for safety

        this.zipCodeInput.style.border = "1px solid red";

        // Try to find existing error message element
        let errorMessageElement =
          this.zipCodeInput.parentNode.querySelector(".zip-error-message");

        // Create error message element if it doesn't exist
        if (!errorMessageElement) {
          errorMessageElement = document.createElement("p");
          errorMessageElement.classList.add("zip-error-message");
          errorMessageElement.style.color = "red";
          errorMessageElement.style.fontSize = "14px";
          // errorMessageElement.style.margin = "0"; // You might want margin
          errorMessageElement.style.marginTop = "5px";
          errorMessageElement.style.lineHeight = "1.3"; // Good for multi-line
          // Insert after the zip code input
          this.zipCodeInput.parentNode.insertBefore(
            errorMessageElement,
            this.zipCodeInput.nextSibling
          );
        }

        // --- THIS IS THE KEY CHANGE ---
        // Use innerHTML to allow rendering of the <a> tag
        errorMessageElement.innerHTML = message;
        // --- END KEY CHANGE ---

        errorMessageElement.style.display = "block"; // Ensure it is visible
      }

      // Show quantity error message
      showQuantityError(quantityInput, message) {
        if (!quantityInput) return;

        quantityInput.style.borderColor = "red";
        quantityInput.style.borderWidth = "2px";

        // Find the quantity-input wrapper
        const quantityWrapper = quantityInput.closest("quantity-input");
        
        // Try to find existing error message element
        let errorMessageElement = null;
        if (quantityWrapper) {
          errorMessageElement = quantityWrapper.parentNode?.querySelector(".quantity-error-message") ||
                               quantityWrapper.nextElementSibling?.classList.contains("quantity-error-message") ?
                               quantityWrapper.nextElementSibling : null;
        } else {
          errorMessageElement = quantityInput.parentNode?.querySelector(".quantity-error-message");
        }

        // Create error message element if it doesn't exist
        if (!errorMessageElement) {
          errorMessageElement = document.createElement("div");
          errorMessageElement.classList.add("quantity-error-message");
          errorMessageElement.style.cssText = "color: #A21D35; font-size: 14px; display: block;";
          
          // Insert after the quantity input wrapper or input itself
          if (quantityWrapper) {
            quantityWrapper.insertAdjacentElement("afterend", errorMessageElement);
          } else {
            quantityInput.parentNode.insertBefore(
              errorMessageElement,
              quantityInput.nextSibling
            );
          }
        }

        errorMessageElement.textContent = message;
        errorMessageElement.style.display = "block";
      }

      // Hide quantity error message
      hideQuantityError(quantityInput) {
        if (!quantityInput) return;

        quantityInput.style.borderColor = "";
        quantityInput.style.borderWidth = "";

        // Find the quantity-input wrapper
        const quantityWrapper = quantityInput.closest("quantity-input");
        
        // Remove error message if exists
        let errorMessageElement = null;
        if (quantityWrapper) {
          errorMessageElement = quantityWrapper.parentNode?.querySelector(".quantity-error-message") ||
                               quantityWrapper.nextElementSibling?.classList.contains("quantity-error-message") ?
                               quantityWrapper.nextElementSibling : null;
        } else {
          errorMessageElement = quantityInput.parentNode?.querySelector(".quantity-error-message");
        }
        
        if (errorMessageElement) {
          errorMessageElement.remove();
        }
      }

      // Handle date selection - show inline message by adding active class
      handleDateSelected() {
        console.log("Date selected - showing inline message");

        // Clear any previous error messages
        this.shippingMethodModel
          .querySelectorAll(".error-message")
          .forEach((el) => el.remove());

        // Remove any error highlighting
        const calendarContainer = this.shippingMethodModel.querySelector(
          ".multiship-calendar__container"
        );
        if (calendarContainer) {
          calendarContainer.classList.remove("error-highlight");
        }

        // Remove calender-error class
        const modalContent = this.shippingMethodModel.querySelector(
          ".modal-address__content"
        );
        if (modalContent) {
          modalContent.classList.remove("calender-error");
        }

        // Show inline message by adding active class
        this.showDateSelectedMessage();
      }

      // Show/hide inline message based on date selection
      showDateSelectedMessage() {
        const dateSelectionMessage = document.getElementById("DateSelectionMessage");
        if (dateSelectionMessage) {
          // Add active class to show the message
          dateSelectionMessage.classList.add("active");
        }
      }

      // Hide inline message when no date is selected
      hideDateSelectedMessage() {
        const dateSelectionMessage = document.getElementById("DateSelectionMessage");
        if (dateSelectionMessage) {
          // Remove active class to hide the message
          dateSelectionMessage.classList.remove("active");
        }
      }

      // Handle date confirmation (when Confirm button is clicked)
      handleDateConfirmed() {
        console.log("Date confirmed - processing form submission");
        const dateSelected = this.isDateSelected();
        
        if (dateSelected) {
          // Close the modal
          this.shippingMethodModel.classList.remove("active");
          removeBodyOverflowHidden();

          // If form submission is pending, process it now
          if (this.formSubmissionPending && this.formData) {
            console.log("Processing pending form submission");
            this.processFormSubmission(this.formData);
          }
        }
      }

      // Handle modal close - just close modal, don't auto-submit
      handleModalClose() {
        // Prevent duplicate calls
        if (this.isClosingModal) {
          return;
        }

        this.isClosingModal = true;
        console.log("Modal close requested - closing without auto-submit");

        // Just close the modal - don't process form submission
        this.shippingMethodModel.classList.remove("active");
        removeBodyOverflowHidden();

        // If no date was selected, reset form submission pending state
        const dateSelected = this.isDateSelected();
        if (!dateSelected) {
          this.formSubmissionPending = false;
          this.formData = null;
        }

        // Reset flag after a short delay
        setTimeout(() => {
          this.isClosingModal = false;
        }, 300);
      }

      // Validate all form fields at once and collect all validation errors
      validateAllFields() {
        let errors = [];
        let age_verification = document.querySelector(
          "#ProductAgeVerification"
        );

        // 1. Validate age verification if present
        if (age_verification && !age_verification.checked) {
          age_verification.parentNode.classList.add("warning");
          errors.push({
            field: "age_verification",
            element: age_verification.parentNode,
            message: "Please confirm you are of legal drinking age.",
          });
        }

        // 2. Validate personal message if it exists
        if (this.personalMessage) {
          if (this.personalMessage.hasEmojis()) {
            this.personalMessage.setWarning(
              "Please note emojis and special characters are not supported in custom engravings."
            );
            errors.push({
              field: "personal_message",
              element: this.personalMessage,
              message:
                "Please remove emojis and special characters from your message.",
            });
          }

          if (!this.personalMessage.isValid()) {
            this.personalMessage.classList.add("warning");
            errors.push({
              field: "personal_message",
              element: this.personalMessage,
              message:
                "Please enter a valid personal message or select 'No message'.",
            });
          }
        }

        // 3. Validate Recipient Email (for gift cards)
        if (!this.validateRecipientEmail()) {
          errors.push({
            field: "recipient_email",
            element: this.recipientEmailInput || this.form,
            message: "Please enter a valid recipient email address.",
          });
        }

        // 4. Validate quantity input
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        if (quantityInput) {
          const quantityValue = quantityInput.value;
          const min = parseInt(quantityInput.min) || 1;
          const max = quantityInput.max ? parseInt(quantityInput.max) : null;
          const step = parseFloat(quantityInput.step) || 1;
          
          // Check if quantity is empty or not a valid number
          if (quantityValue === '' || quantityValue === null || quantityValue === undefined || isNaN(quantityValue)) {
            this.showQuantityError(quantityInput, 'Please enter a valid quantity.');
            errors.push({
              field: "quantity",
              element: quantityInput,
              message: "Please enter a valid quantity.",
            });
          } else {
            const numValue = parseFloat(quantityValue);
            
            // Check if value is negative
            if (numValue < 0) {
              this.showQuantityError(quantityInput, 'Quantity cannot be negative. Please enter a positive number.');
              errors.push({
                field: "quantity",
                element: quantityInput,
                message: "Quantity cannot be negative. Please enter a positive number.",
              });
            }
            // Check if value is less than minimum
            else if (numValue < min) {
              this.showQuantityError(quantityInput, `Minimum quantity is ${min}.`);
              errors.push({
                field: "quantity",
                element: quantityInput,
                message: `Minimum quantity is ${min}.`,
              });
            }
            // Check if value exceeds maximum (if max is set)
            else if (max !== null && numValue > max) {
              this.showQuantityError(quantityInput, `Maximum quantity is ${max}.`);
              errors.push({
                field: "quantity",
                element: quantityInput,
                message: `Maximum quantity is ${max}.`,
              });
            }
            // Check if value is not an integer (if step is 1)
            else if (step === 1 && !Number.isInteger(numValue)) {
              this.showQuantityError(quantityInput, 'Please enter a whole number.');
              errors.push({
                field: "quantity",
                element: quantityInput,
                message: "Please enter a whole number.",
              });
            }
            // Check if value matches step increment
            else if (step > 0 && (numValue % step) !== 0) {
              this.showQuantityError(quantityInput, `Quantity must be in increments of ${step}.`);
              errors.push({
                field: "quantity",
                element: quantityInput,
                message: `Quantity must be in increments of ${step}.`,
              });
            } else {
              // Clear any error messages if validation passes
              this.hideQuantityError(quantityInput);
            }
          }
        }

        // 5. Validate ZIP code if it exists
        if (this.zipCodeInput) {
          const zipValue = this.zipCodeInput.value.trim();

          // Check if ZIP code is empty
          if (!zipValue) {
            const zipcodeBlankError = document.querySelector(
              ".zipcode_blank_error"
            );
            if (zipcodeBlankError) {
              zipcodeBlankError.style.display = "block";
            }
            this.zipCodeInput.style.border = "1px solid red";
            errors.push({
              field: "zipcode",
              element: this.zipCodeInput,
              message: "ZIP code is required.",
            });
          } else {
            const state = this.getStateForZipCode(zipValue);
            if (
              this.restrictedStates &&
              state &&
              this.restrictedStates.includes(state)
            ) {
              this.showZipCodeError(
                `This gift cannot be shipped to ${state} because of restrictions.`
              );
              errors.push({
                field: "zipcode",
                element: this.zipCodeInput,
                message: `Due to alcohol shipping restrictions, we are unable to ship alcohol gifts to ${state}. <a href="/collections/wine-and-chocolate-gifts"  rel="noopener noreferrer" style="text-decoration:underline;">Click here</a> for our best selling gifts you can send to this zip code!`,
              });
            } else if (!this.validateZipCode()) {
              // ZIP code validation already handles showing error messages
              errors.push({
                field: "zipcode",
                element: this.zipCodeInput,
                message: "Invalid ZIP code or not in our service area.",
              });
            }
          }
        }

        return errors;
      }

      getMultiPackPicker() {
        const formId = this.form?.id;
        if (formId) {
          const scoped = document.querySelector(
            `multi-pack-picker[data-form-id="${formId}"]`
          );
          if (scoped) return scoped;
        }
        return (
          this.closest("product-info")?.querySelector("multi-pack-picker") ||
          document.querySelector("multi-pack-picker")
        );
      }

      syncMultiPackFormState() {
        const picker = this.getMultiPackPicker();
        if (!picker) return;

        if (typeof picker.ensureVariantIdOnForm === "function") {
          picker.ensureVariantIdOnForm();
        }
        if (typeof picker.syncFormForSubmit === "function") {
          picker.syncFormForSubmit();
          return;
        }

        const qty =
          typeof picker.getLineQuantity === "function"
            ? picker.getLineQuantity()
            : parseInt(picker.selectedPack, 10) || 1;
        const qtyValue = String(Math.max(1, qty));
        const inputs = new Set();
        this.form
          ?.querySelectorAll('input[name="quantity"]')
          .forEach((input) => inputs.add(input));
        if (this.form?.id) {
          document
            .querySelectorAll(`input[name="quantity"][form="${this.form.id}"]`)
            .forEach((input) => inputs.add(input));
        }
        inputs.forEach((input) => {
          input.value = qtyValue;
        });
        if (picker.packProperty) {
          picker.packProperty.value = String(picker.selectedPack || qtyValue);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.syncMultiPackFormState();

        // Create formData for later use
        this.formData = new FormData(this.form);

        if (this.submitButton?.getAttribute("aria-disabled") === "true") return;

        // MAIN CHANGE: Validate all fields at once and collect all errors
        const validationErrors = this.validateAllFields();

        // If there are validation errors, display them all at once and stop the form submission
        if (validationErrors.length > 0) {
          console.log("Validation errors found:", validationErrors);
          // Remove any previous success states
          if (this.personalMessage) {
            this.personalMessage.classList.remove("success");
          }
          if (document.querySelector("#ProductAgeVerification")) {
            document
              .querySelector("#ProductAgeVerification")
              .parentNode.classList.remove("success");
          }

          // Focus on the first error field for accessibility
          if (validationErrors[0].element) {
            validationErrors[0].element.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }

          return; // Stop form submission if there are errors
        }

        // Clear any previous warnings
        if (document.querySelector("#ProductAgeVerification")) {
          document
            .querySelector("#ProductAgeVerification")
            .parentNode.classList.remove("warning");
        }
        if (this.personalMessage) {
          this.personalMessage.classList.remove("warning");
          this.personalMessage.removeWarning();
        }

        // At this point, all validations have passed

        // Check if we need to show the shipping method modal
        if (
          this.zipCodeInput &&
          this.shippingMethodModel &&
          this.isZipCodeValid
        ) {
          this.shippingMethodModel.classList.add("active");
          // Add this line to add overflow-hidden to body:
          addBodyOverflowHidden();
          // Set the form submission as pending
          this.formSubmissionPending = true;

          // Check if the user has already selected a date
          const shippingMethods =
            this.shippingMethodModel.querySelector("shipping-methods");
          if (
            shippingMethods &&
            shippingMethods.loadSelectedDate &&
            shippingMethods.loadSelectedDate()
          ) {
            // If date already selected, just mark it (don't close modal)
            const productElement =
              this.shippingMethodModel.querySelector(".product");
            if (productElement) {
              productElement.classList.add("Selecteddate");
              productElement.classList.remove("calender-error");
            }
            // Show the inline message
            this.showDateSelectedMessage();
          } else {
            // No date selected - hide the message
            this.hideDateSelectedMessage();
          }

          // Return early - don't process form submission yet
          return;
        }

        // Process form submission directly if modal not needed or date already selected
        this.processFormSubmission(this.formData);
      }

      setSubmitButtonLoading(loading) {
        if (!this.submitButton) return;

        const spinner = this.submitButton.querySelector(
          ".loading__spinner, .loading-overlay__spinner"
        );
        const isLoading = Boolean(loading);

        this.submitButton.classList.toggle("loading", isLoading);

        if (isLoading) {
          this.submitButton.setAttribute("aria-disabled", "true");
          spinner?.classList.remove("hidden");
        } else {
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          spinner?.classList.add("hidden");
        }
      }

      async processFormSubmission(formData) {
        this.formSubmissionPending = false;

        // Remove overflow-hidden to ensure it's not stuck if modal was closed in an unusual way
        removeBodyOverflowHidden();

        this.handleErrorMessage();

        this.setSubmitButtonLoading(true);

        const config = fetchConfig("javascript");

        // Get the delivery date from shipping-methods component or localStorage
        let deliveryDate = null;

        // Method 1: Try to get from shipping-methods component
        const shippingMethods = document.querySelector("shipping-methods");
        if (
          shippingMethods &&
          typeof shippingMethods.getDeliveryDate === "function"
        ) {
          deliveryDate = shippingMethods.getDeliveryDate();
          console.log(
            "Got delivery date from shipping-methods.getDeliveryDate():",
            deliveryDate
          );
        }

        // Method 2: Try to get from localStorage if method 1 failed
        if (!deliveryDate) {
          // Get product ID for localStorage key
          const product = document.querySelector(".product");
          const productId = product
            ? product.dataset.gid || product.dataset.earliestShipDate
            : null;
          const localStorageKey = `selectedDate_${productId || "default"}`;
          deliveryDate = localStorage.getItem(localStorageKey);
          console.log("Got delivery date from localStorage:", deliveryDate);
        }

        // Method 3: Try to get from selected date in calendar
        if (!deliveryDate) {
          const selectedDateCell = document.querySelector(
            ".air-datepicker-cell.-selected-"
          );
          if (selectedDateCell) {
            // Get date from cell's data attributes if possible
            const year = new Date().getFullYear();
            const month = selectedDateCell.closest(".air-datepicker-body")
              .dataset.month;
            const day = selectedDateCell.innerText.split("\n")[0]; // Get just the day number

            if (month !== undefined && day) {
              deliveryDate = new Date(year, month, day).toDateString();
              console.log(
                "Got delivery date from selected cell:",
                deliveryDate
              );
            }
          }
        }

        // Method 4: Try to get from delivery-date element
        if (!deliveryDate) {
          const deliveryDateElem = document.querySelector(".delivery-date");
          if (deliveryDateElem && deliveryDateElem.textContent) {
            deliveryDate = deliveryDateElem.textContent;
            console.log(
              "Got delivery date from delivery-date element:",
              deliveryDate
            );
          }
        }

        // Get the zipcode value
        const zipcode = this.zipCodeInput ? this.zipCodeInput.value : null;
        console.log("Get valid zipcode value", zipcode);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        var quantity = 1;
        let mergeExistingLine = false;
        let existingLineProps = null;
        let cartDataForFeeCheck = null;

        // Build request differently for gift card to avoid bundle/multi-item flow
        if (this.isGiftCard) {
          // Build single item payload (no bundle grouping/_gid for gift cards)
          const singleItem = {
            id: "",
            quantity: 1,
            properties: {},
          };

          // Add optional properties
          if (zipcode) {
            singleItem.properties._zipcode = zipcode;
          }
          if (deliveryDate) {
            singleItem.properties._delivery_date = deliveryDate;
          }

          formData.forEach((value, key) => {
            if (key === "quantity") {
              quantity = value;
              singleItem.quantity = value;
            } else if (key === "id[]" || key === "id") {
              singleItem.id = value;
            } else if (key.indexOf("properties") > -1) {
              var property = key.split("[")[1].split("]")[0];
              singleItem.properties[property] = value;
            }
          });

          // For single item add, send id/quantity/properties plus sections for drawer refresh
          let sections = [];
          if (this.cart) {
            this.cart.getSectionsToRender().forEach((section) => {
              sections.push(section.id);
            });
          }
          const body = {
            id: singleItem.id,
            quantity: Number(singleItem.quantity) || 1,
            properties: singleItem.properties,
            sections: sections.join(","),
            sections_url: window.location.pathname,
          };

          console.log("Gift card add body:", body);
          config.body = JSON.stringify(body);
        } else {
          const variantId =
            formData.get("id") || formData.get("id[]") || this.form?.querySelector('[name="id"]')?.value;
          const cartMerge = window.chukarCartMerge;
          const picker = this.getMultiPackPicker();
          const pickerQty =
            picker && typeof picker.getLineQuantity === "function"
              ? picker.getLineQuantity()
              : 0;
          const addQty = Math.max(1, pickerQty || Number(formData.get("quantity")) || 1);

          // Same variant already in cart (e.g. added from PLP) → bump qty, do not cart/add.
          if (
            variantId &&
            cartMerge &&
            typeof cartMerge.incrementExistingVariantQuantity === "function"
          ) {
            try {
              const sections = this.cart
                ? this.cart
                    .getSectionsToRender()
                    .map((section) => section.id)
                    .filter(Boolean)
                : ["cart-drawer", "cart-icon-bubble"];
              const mergeResult =
                await cartMerge.incrementExistingVariantQuantity(
                  variantId,
                  addQty,
                  {
                    cart: this.cart,
                    sections: sections.join(","),
                    sectionsUrl: window.location.pathname,
                    wine: this.wine,
                  }
                );

              if (mergeResult && mergeResult.merged) {
                if (!this.error) {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: variantId,
                  });
                }
                this.error = false;
                this.clearFormFields();
                this.setSubmitButtonLoading(false);
                if (this.cart && this.cart.classList.contains("is-empty")) {
                  this.cart.classList.remove("is-empty");
                }
                return;
              }
            } catch (mergeErr) {
              console.warn("PDP cart merge increment failed:", mergeErr);
            }
          }

          if (variantId && cartMerge) {
            try {
              let cartData = await cartMerge.fetchCartJson();
              cartDataForFeeCheck = cartData;
              const findMergeLines =
                cartMerge.findPdpLinesForVariant || cartMerge.findPlpLinesForVariant;
              let mergeLines = findMergeLines(cartData.items, variantId);

              if (mergeLines.length > 1) {
                await cartMerge.removeDuplicatePlpLines(mergeLines);
                cartData = await cartMerge.fetchCartJson();
                mergeLines = findMergeLines(cartData.items, variantId);
              }

              const primary = mergeLines[0] || null;
              if (primary) {
                mergeExistingLine = true;
                existingLineProps = primary.properties || {};
              }
            } catch (mergeErr) {
              console.warn("PDP cart merge check failed:", mergeErr);
            }
          }

          this.random =
            (existingLineProps && existingLineProps._gid) ||
            Math.random().toString().slice(2, 11);

          // Original multi-item flow
          var cartObject = {
            items: [],
            sections: [],
            sections_url: window.location.pathname,
          };

          // Create the main product item with properties
          var formObject = {
            id: "",
            quantity: 1,
            properties: {
              _gid: this.random,
            },
          };

          // Mark this as the main product line for shipping / tier calculations
          formObject.properties._product = "true";

          if (mergeExistingLine && existingLineProps) {
            Object.assign(formObject.properties, existingLineProps, {
              _gid: this.random,
              _product: "true",
            });
          }

          // Only attach shipping props on a net-new line. Changing them on merge
          // makes Shopify treat the add as a different line item.
          if (!mergeExistingLine) {
            if (zipcode) {
              formObject.properties._zipcode = zipcode;
            }

            if (deliveryDate) {
              formObject.properties._delivery_date = deliveryDate;
            }
          }

          formData.forEach((value, key) => {
            if (key == "quantity") {
              quantity = value;
            }

            if (key == "id[]" || key == "id") {
              formObject["id"] = value;
            } else if (key.indexOf("properties") > -1) {
              // Keep existing line properties intact when merging qty.
              if (mergeExistingLine) return;
              formObject["properties"] = formObject["properties"] || {};

              var property = key.split("[")[1].split("]")[0];
              formObject["properties"][property] = value;
            } else {
              formObject[key] = value;
            }
          });

          // Attach main product single-unit price as _main_fees (used for tiered shipping).
          // Skip when merging — property changes prevent Shopify from combining line items.
          if (!mergeExistingLine) {
            try {
              const unitPrice = this.getMainProductUnitPrice
                ? this.getMainProductUnitPrice()
                : null;
              if (unitPrice && !isNaN(unitPrice)) {
                const perUnit = parseFloat(unitPrice.toFixed(2)); // dollars
                formObject.properties._main_fees = String(perUnit);
              }
            } catch (e) {
              console.warn("Unable to determine main product price for _main_fees", e);
            }
          }

          formObject.quantity = Number(quantity) || 1;
          if (pickerQty) {
            quantity = pickerQty;
            formObject.quantity = pickerQty;
          }

          if (!formObject.id) {
            const pickerVariantId = picker?.dataset?.variantId;
            if (pickerVariantId) {
              formObject.id = pickerVariantId;
            }
          }

          // Log the form object for debugging
          console.log("Form object with properties:", formObject);

          cartObject.items.push(formObject);

          if (this.cart) {
            this.cart.getSectionsToRender().forEach((section) => {
              cartObject.sections.push(section.id);
            });
            cartObject.sections = cartObject.sections.join(",");

            this.cart.setActiveElement(document.activeElement);
          }

          if (!mergeExistingLine && this.wine) {
            const signatureFeeLine = getSignatureFeeCartLineFromConfig();
            const feeAlreadyInCart =
              cartDataForFeeCheck &&
              cartHasSignatureFeeForGid(cartDataForFeeCheck.items, this.random);
            if (signatureFeeLine && !feeAlreadyInCart) {
              cartObject.items.push({
                id: signatureFeeLine.id,
                quantity: quantity,
                properties: {
                  _gid: this.random,
                  _fee: true,
                  [PDP_LINE_PROP_FEES]: signatureFeeLine.feeDisplay,
                },
              });
            }
          }

          if (!mergeExistingLine) {
          document.querySelectorAll("product-ribbon").forEach((ribbon) => {
            var input = ribbon.querySelector("input:checked");

            if (input) {
              var ribbonObject = {
                id: input.value,
                quantity: quantity,
                properties: {
                  _ribbon: true,
                  _gid: this.random,
                },
              };

              if (
                input.getAttribute("data-type") ==
                  "select-a-ribbon-your-own-message" ||
                input.getAttribute("data-type") ==
                  "select-a-ribbon-personalized-message"
              ) {
                ribbonObject["properties"]["message"] = document.querySelector(
                  "#ProductRibbonMessage"
                ).value;
                ribbonObject["properties"][PDP_LINE_PROP_FEES] = "$9.95";
              }

              if (
                input.getAttribute("data-type") != "classic" ||
                input.getAttribute("data-type") != "Ribbon Included"
              ) {
                document
                  .querySelectorAll("[name='ribbon_color']")
                  .forEach((color) => {
                    if (color.checked) {
                      ribbonObject["properties"]["color"] = color.value;
                      ribbonObject["properties"][PDP_LINE_PROP_FEES] = "$0.00";
                    }
                  });
              }

              if (
                input.getAttribute("data-type") == "thank-you" ||
                input.getAttribute("data-type") == "occasion"
              ) {
                ribbonObject["properties"]["Occasion"] =
                  document.querySelector("#occasioned").value;
                ribbonObject["properties"][PDP_LINE_PROP_FEES] = "$7.95";
              }

              cartObject.items.push(ribbonObject);
            }
          });
          }

          // Reverse the items array to maintain proper order
          cartObject.items.reverse();

          // Log the final cart object before sending
          console.log("Final cart object:", cartObject);

          config.body = JSON.stringify(cartObject);
        }

        const cartAddUrl =
          window.chukarCartMerge && typeof window.chukarCartMerge.toCartJsEndpoint === "function"
            ? window.chukarCartMerge.toCartJsEndpoint(routes.cart_add_url)
            : routes.cart_add_url;

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            this.clearFormFields();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.setSubmitButtonLoading(false);
          });
      }

      // Helper method to check if a date is selected
      isDateSelected() {
        const shippingMethodsElement =
          this.shippingMethodModel.querySelector("shipping-methods");

        console.log("Checking if date is selected");

        try {
          // Check multiple ways to determine if a date is selected
          if (shippingMethodsElement) {
            // First and most reliable check: Is there a selected date cell in the calendar?
            const selectedDateCell = this.shippingMethodModel.querySelector(
              ".air-datepicker-cell.-selected-"
            );
            if (selectedDateCell) {
              console.log(
                "Found selected date cell in UI:",
                selectedDateCell.textContent
              );
              return true;
            }

            // Second check: Does the product element have the 'Selecteddate' class?
            const productElement =
              this.shippingMethodModel.querySelector(".product");
            if (
              productElement &&
              productElement.classList.contains("Selecteddate")
            ) {
              console.log("Product has Selecteddate class");
              return true;
            }

            // Don't use the validate method - it may be returning true incorrectly

            // Third check: Check localStorage for saved date
            const product = document.querySelector(".product");
            let savedDate = null;

            if (
              shippingMethodsElement.loadSelectedDate &&
              typeof shippingMethodsElement.loadSelectedDate === "function"
            ) {
              try {
                savedDate = shippingMethodsElement.loadSelectedDate();
              } catch (e) {
                console.error("Error in loadSelectedDate:", e);
                // Continue checking other methods
              }
            }

            if (!savedDate && product && product.dataset.gid) {
              savedDate = localStorage.getItem(
                `selectedDate_${product.dataset.gid}`
              );
            }

            if (savedDate) {
              console.log("Found saved date in localStorage:", savedDate);
              return true;
            }

            // Check if delivery date is showing actual date and not an estimate
            const deliveryDates =
              this.shippingMethodModel.querySelectorAll(".delivery-date");
            for (const dateEl of deliveryDates) {
              const dateText = dateEl.textContent.trim();
              // Only consider it a selected date if it doesn't contain estimate-related terms
              if (
                dateText &&
                !dateText.includes("Estimated") &&
                !dateText.includes("Day") &&
                !dateText.includes("Days") &&
                // Avoid matching just numbers
                dateText.length > 5
              ) {
                console.log(
                  "Found populated delivery date (actual date):",
                  dateText
                );
                return true;
              }
            }
          }

          console.log("No selected date found through any method");
          return false;
        } catch (error) {
          console.error("Error in isDateSelected:", error);
          return false; // Default to false on error
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          // Custom error message and hyperlink for the phone number
          const customErrorMessage =
            "For larger orders, please contact Corporate Sales at ";
          const phoneNumber = "800-624-9544";
          const phoneLink = document.createElement("a");
          phoneLink.href = "tel:8006249544";
          phoneLink.textContent = phoneNumber;

          this.errorMessage.textContent = customErrorMessage;
          this.errorMessage.appendChild(phoneLink);
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        
        const submitButtonText = this.submitButton.querySelector('span');
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        
        if (disable) {
          // Disable the button
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          
          // Set the text - use provided text or default to "Sold out"
          const displayText = text || window.variantStrings?.soldOut || 'Sold out';
          if (submitButtonText) {
            submitButtonText.textContent = displayText;
            submitButtonText.classList.remove('hidden');
          }
          
          // Show sold-out message element if it exists and we're showing sold out text
          if (soldOutMessage) {
            const isSoldOutText = displayText === (window.variantStrings?.soldOut || 'Sold out') || 
                                  displayText.toLowerCase().includes('sold out');
            if (isSoldOutText) {
              soldOutMessage.classList.remove('hidden');
              if (submitButtonText) submitButtonText.classList.add('hidden');
            } else {
              soldOutMessage.classList.add('hidden');
            }
          }
        } else {
          // Enable the button
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          
          // Reset to "Add to cart" text
          if (submitButtonText) {
            submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
            submitButtonText.classList.remove('hidden');
          }
          
          // Hide sold-out message
          if (soldOutMessage) {
            soldOutMessage.classList.add('hidden');
          }
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name="id"]');
      }
    }
  );
}

if (!customElements.get("personal-message")) {
  customElements.define(
    "personal-message",
    class PersonalMessage extends HTMLElement {
      constructor() {
        super();

        this.valid = false;
        this.withEmojis = /\p{Extended_Pictographic}/u;

        this.optOut = this.querySelector(".personal-message__opt-out input");
        this.messages = this.querySelectorAll(".personal-message__body");
        this.warning = this.querySelector(".personal-warning");

        this.optOut.addEventListener("change", this.toggleMessages.bind(this));
      }

      setWarning(text) {
        this.warning.innerHTML = text;
      }

      removeWarning() {
        this.warning.innerHTML = "";
      }

      hasEmojis() {
        if (this.withEmojis.test(this.messages[0].value.trim())) {
          return true;
        }

        if (
          this.messages[1] &&
          this.withEmojis.test(this.messages[1].value.trim())
        ) {
          return true;
        }

        return false;
      }

      isValid() {
        if (this.optOut.checked) {
          this.valid = true;
        } else if (this.messages[0].value.trim() !== "") {
          if (this.withEmojis.test(this.messages[0].value.trim())) {
            this.valid = false;
            return this.valid;
          }

          if (this.messages[1] && this.messages[1].value.trim() == "") {
            if (this.withEmojis.test(this.messages[1].value.trim())) {
              this.valid = false;
              return this.valid;
            }

            this.valid = false;
            return this.valid;
          }

          this.valid = true;
        } else {
          this.valid = false;
        }

        return this.valid;
      }

      toggleMessages() {
        this.messages.forEach((message) => {
          message.toggleAttribute("disabled");
        });
      }
    }
  );
}